export enum DecisionResultListColumnSizes {
  StrategyName = 30,
  Name = 30,
  ExecutionTime = 20,
  Type = 20,
}
